import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import TestSketch from "./P5/zylinder"
import cat from '../images/gelber_sack/cat.png'; 
import gopnik from '../images/gelber_sack/gopnik.png'; 
import pitbull from '../images/gelber_sack/pitbull.jpg'; 
const GelberSack = () => {
  return (
    <>
      <Container>
        <h1>GELBER SACK</h1>
        <p><i>Fungrube</i> with other art Stuff. Enjoy ^_^</p>
       
      </Container>


      <Container>
        <Row>
          <Col>
          </Col>
          <Col className="">
            <h2 style={{ textAlignVertical: "center", textAlign: "center", }}>Very Fat Cat eating lasagne 🖌 <span><i>  DALLE </i></span></h2>
            <img src={cat} />

            <h2 style={{ textAlignVertical: "center", textAlign: "center", }}>Gopnik smoking a cig 🖌 <span><i>  DreamStudio </i></span></h2>
            <img src={gopnik} />
   
            <h2 style={{ textAlignVertical: "center", textAlign: "center", }}>Pitbull holding a cat   🖌 <span><i>  DreamStudio </i></span></h2>
            <img src={pitbull} />
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </>
  )
}

export default GelberSack
